import { SITE_CONFIG, type SiteId } from '@veranda/shared/lib/constants';

/**
 * Get the site configuration for a given site ID with environment-aware URL selection
 */
export const getSiteConfig = (siteId: SiteId) => {
  const configKey = siteId.toUpperCase() as keyof typeof SITE_CONFIG;
  const config = SITE_CONFIG[configKey];

  if (!config) {
    throw new Error(`Site config not found for site ID: ${siteId}`);
  }

  return {
    name: config.name,
    id: config.id,
    baseUrl:
      process.env.NODE_ENV === 'production' ? config.href : config.devHref,
    currencyCode: config.currencyCode,
    locale: config.locale,
  } as const;
};

/**
 * Create a site config object for a given site ID - alias for getSiteConfig
 */
export const createSiteConfig = getSiteConfig;
